<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    title="获取二维码海报"
    width="940px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <qr-code-share :qr-text="qrText" :download-name="downloadName" :download-sub="downloadSub" />
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'
import QrCodeShare from '../base/QrCodeShare.vue'

export default {
  name: 'QrPictorialDialog',
  mixins: [dialogMixins],
  components: {
    QrCodeShare
  },
  props: {
    qrText: {
      type: String,
      default: ''
    },
    downloadName: {
      type: String,
      default: ''
    },
    downloadSub: {
      type: String,
      default: ''
    }
  }
}
</script>
